import React from 'react'
import { Grid } from '@mui/material'
import { useOutletContext, useParams } from 'react-router-dom'
import { useGetSellerQuery } from '../../../../../../redux/slices/sellerContentSlice'
import { getSellerPagePath } from '../../../../../../setup/routeConstants'
import { StyledLink } from '../../../../../StyledLink'

const style = { fontFamily: 'monospace' }

function Specs() {
  const { listing, partner, affiliate } = useOutletContext()
  const { id: listingId } = useParams()
  const { data: seller } = useGetSellerQuery(listingId, { skip: !listingId })

  const sellerPageUrl = seller?.id
    ? getSellerPagePath(seller.id, seller.seoSlug)
    : null

  return (
    <Grid container>
      {seller && (
        <>
          <Grid item xs={2}>Seller Id</Grid>
          <Grid item xs={10}><span style={style}>{seller.id}</span></Grid>
        </>
      )}
      <Grid item xs={2}>Listing Id</Grid>
      <Grid item xs={10}><span style={style}>{listing?.id}</span></Grid>
      {affiliate?.id && (
        <>
          <Grid item xs={2}>Affiliate Id</Grid>
          <Grid item xs={10}><span style={style}>{affiliate.id}</span></Grid>
        </>
      )}
      <Grid item xs={2}>Partner Id</Grid>
      <Grid item xs={10}><span style={style}>{partner?.id}</span></Grid>
      <Grid item xs={2}>Partner Name</Grid>
      <Grid item xs={10}><span style={style}>{partner?.name}</span></Grid>
      <Grid item xs={2}>Source</Grid>
      <Grid item xs={10}><span style={style}>{partner?.source}</span></Grid>
      <Grid item xs={2}>Source Key</Grid>
      <Grid item xs={10}><span style={style}>{partner?.sourceKey}</span></Grid>
      {seller && sellerPageUrl && (
        <>
          <Grid item xs={2}>Seller Page</Grid>
          <Grid item xs={10}>
            <StyledLink
              external
              to={sellerPageUrl}
              newWindow
              contents={sellerPageUrl}
            />
          </Grid>
        </>
      )}
    </Grid>
  )
}

export default Specs
